<template>
  <div v-if="specialists" class="page-wrapper">
    <div class="container-custom heading" @scroll-to-full-description="scrollToFullDescription">
      <OneDoctorHeadingComponent
          :booking="booking"
          :category="specialists.content.category.value"
          :description="specialists.content.description"
          :email="specialists.content.email"
          :image-url="specialists.content.imageUrl[0]"
          :phone="specialists.content.phone"
          :title="specialists.content.name"
          @scroll-to-full-description="scrollToFullDescription"
      />

    </div>
    <div v-if="specialists.content.specialistInformation" ref="fullDescription"
         class="container-custom description-wrapper">
      <TitlesDescriptionComponent :size="'small'" :title="$t('one-specialist-description-title')"/>
      <DescriptionWYSIWYG :description="specialists.content.specialistInformation"/>
    </div>
  </div>
</template>

<script>

import OneDoctorHeadingComponent from "@/components/Components/OneDoctorHeadingComponent/OneDoctorHeadingComponent.vue";
import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import DescriptionWYSIWYG from "@/components/Components/DescriptionWYSIWYG/DescriptionWYSIWYG.vue";

export default {
  name: 'OneDoctorsView',
  components: {
    DescriptionWYSIWYG,
    TitlesDescriptionComponent,
    OneDoctorHeadingComponent
  },

  data() {
    return {
      specialists: null,
      specialistHeading: {},
      specialistInformation: {},
      booking: {}
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    this.specialists = await this.$store.dispatch("specialists/getSpecialist", {id: id});
    this.booking = {
      uin: this.specialists.content.bookingUin,
      hosp: this.specialists.content.bookingHosp,
      spec: this.specialists.content.bookingSpec,
    }
  },
  methods: {
    scrollToFullDescription() {
      const fullDescriptionElement = this.$refs.fullDescription;
      if (fullDescriptionElement) {
        fullDescriptionElement.scrollIntoView({behavior: 'smooth'});
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.heading {
  margin-top: 130px;
  margin-bottom: 50px;
}

.description-wrapper {
  margin-bottom: $spacing-11;
}


@media screen and (min-width: 768px) {
  .heading {
    margin-top: 180px;
  }

}
</style>